<template>
  <div style="text-align: center">
    <div class="p-grid">
      <div class="p-col-12 p-mt-5">
        <h1>Backend nicht erreichbar</h1>
      </div>
      <div class="p-col-12 p-mt-5">
        Das Backend ist nicht erreichbar, versuchen sie es erneut oder kontaktieren Sie eine(n)
        Verantwortliche/Verantwortlichen.
      </div>
      <div class="p-col-12">
        <Button label="Erneut versuchen" v-on:click="retry"></Button>
      </div>
    </div>

  </div>
</template>

<script>
export default {
  name: "ErrorPage",
  methods: {
    retry() {
      window.location.reload();
    }
  }
}
</script>

<style scoped>

</style>